import { render, staticRenderFns } from "./DKLXResultPage.vue?vue&type=template&id=664bc241&scoped=true"
import script from "./DKLXResultPage.vue?vue&type=script&lang=js"
export * from "./DKLXResultPage.vue?vue&type=script&lang=js"
import style0 from "./DKLXResultPage.vue?vue&type=style&index=0&id=664bc241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664bc241",
  null
  
)

export default component.exports